import { StaticImage } from "gatsby-plugin-image"
import * as React from "react"
import { PopupButton } from "react-calendly"

export const HireResource = () => {
  const [theme, setTheme] = React.useState<string | null>("")
  React.useEffect(() => {
    const interval = setInterval(() => {
      const currentTheme = localStorage.getItem("theme")
      setTheme(currentTheme)
    }, 500)

    return () => clearInterval(interval)
  }, [])

  const [rootElement, setRootElement] = React.useState<HTMLElement | null>(null)

  React.useEffect(() => {
    if (typeof window !== "undefined") {
      const element = document.getElementById("___gatsby")
      setRootElement(element)
    }
  }, [])
  return (
    <>
      <div className=" relative lg:mt-0 lg:py-10 ">
        <div className="absolute lg:top-[30%] top-[35%] left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-10">
          <p className="lg:text-3xl md:text-[15px] sm:text-[12px] text-[10px] text-nowrap text-black font-semibold text-center">
            Scale your professional{" "}
            <span className="text-[#7B68EC]">workforce</span> with{" "}
            <span className="text-gradient-secondary">visual folio</span>{" "}
            experts, <br /> under our observations in one roof to assure the
            quality!
          </p>
          <div className="flex justify-center lg:mt-4 mt-2">
            <div className=" border w-fit border-with-theme py-3 px-3 relative">
              <div className="w-2 h-2 rounded-purple rounded-full absolute top-[-4px] left-[-4px]"></div>
              <div className="w-2 h-2 rounded-purple rounded-full absolute top-[-4px] left-[50%]"></div>
              <div className="w-2 h-2 rounded-purple rounded-full absolute top-[-4px] right-[-4px]"></div>
              <div className="w-2 h-2 rounded-purple rounded-full absolute bottom-[-4px] left-[-4px]"></div>
              <div className="w-2 h-2 rounded-purple rounded-full absolute bottom-[-4px] left-[50%]"></div>
              <div className="w-2 h-2 rounded-purple rounded-full absolute bottom-[-4px] right-[-4px]"></div>
              <p className="text-center text-[#7B68EC] lg:text-xl md:text-[10px] text-[6px]">
                We respect your ideas & IP, And never share it with others.
                <br /> Everything is confidential
              </p>
            </div>
          </div>
          <p className="flex font-semibold lg:text-3xl text-[7px] text-black items-center justify-center mt-3">
            Hire a{" "}
            <StaticImage
              className="lg:w-40 w-12"
              src="./resource.png"
              alt="resourceHero"
              placeholder="blurred"
              // layout="fullWidth"
            ></StaticImage>{" "}
            you can trust!
          </p>
          <div className="flex justify-center">
            {rootElement && (
              <PopupButton
                className="lg:px-4 lg:py-3 p-2 bg-header-unique-btn text-black font-inter lg:text-sm text-[5px] whitespace-nowrap font-semibold shadow-3xl hover:opacity-70 transition duration-100 ease-in book-free-consultancy-radius bg-btn bg-glass"
                url="https://calendly.com/visualfolio-info/30min"
                rootElement={rootElement}
                text="Hire a Expert which is best fit for your Need"
              />
            )}
          </div>
        </div>
        {theme === "glassy" ? (
          <div>
            <StaticImage
              className="mx-3 lg:mx-0"
              src="./map-bg-glassy.png"
              alt="resourceHero"
              placeholder="blurred"
              layout="fullWidth"
            />
          </div>
        ) : theme === "light" ? (
          <div>
            <StaticImage
              className="mx-3 lg:mx-0"
              src="./map-bg-light.png"
              alt="resourceHero"
              placeholder="blurred"
              layout="fullWidth"
            />
          </div>
        ) : theme === "dark" ? (
          <div>
            <StaticImage
              className="mx-3 lg:mx-0"
              src="./map-bg-dark.png"
              alt="resourceHero"
              placeholder="blurred"
              layout="fullWidth"
            />
          </div>
        ) : (
          <div>
            <StaticImage
              className="mx-3 lg:mx-0"
              src="./map-bg-glassy.png"
              alt="resourceHero"
              placeholder="blurred"
              layout="fullWidth"
            />
          </div>
        )}
      </div>
    </>
  )
}
